import React from 'react'
import t from 'prop-types'

import { PantallaIndice } from 'ibook-api'
import BotoneraIndice from './botonera-indice'
import ContenedorIndiceGameGenerator from './contenedor-indice-game-generator';

class PantallaSeleccionarJuego extends React.Component {
    static propTypes = {
        configIndice: t.shape({
            juegos: t.array.isRequired,
            indexJuegoInicial: t.number,
            textoAtras: t.string,
            textoContinuar: t.string
        }).isRequired,
        onContinuar: t.func.isRequired,
        onAtras: t.func.isRequired,
        onTip: t.func.isRequired
    }

    constructor(props) {
        super(props)

        const parametrosSeleccionados = props.configIndice.juegos.map( 
            juego => juego.parametros.map( parametro => parametro.opciones[0].id ) 
        )

        this.state = {
            indexJuegoSeleccionado: props.configIndice.indexJuegoInicial || 0,
            parametrosSeleccionados,
            plantillaId: null,
            plantilla: {}
        }
    }

    componentDidMount () {
        const index = this.props.configIndice.indexJuegoInicial || 0
        this.handleSeleccionarJuego(index)
    }

    handleSeleccionarJuego = (index) => {
        // const juego = this.props.configIndice.juegos[indexJuegoSeleccionado]
        // const parametrosSeleccionados = juego.parametros.map( (parametro) => parametro.opciones[0].id)
        // this.setState({indexJuegoSeleccionado, parametrosSeleccionados })
        this.setState(
            { indexJuegoSeleccionado: index }, 
            () => this.setState({ plantillaId: this.getNombrePlantilla() })
        )
    }

    handleSeleccionarParametro = (indexParametro, opcionId) => {
        // const { onPlantillaSeleccionada } = this.props
        const { indexJuegoSeleccionado } = this.state
        const parametrosJuegoSeleccionado = [...this.state.parametrosSeleccionados[indexJuegoSeleccionado]]
        parametrosJuegoSeleccionado[indexParametro] = opcionId

        const parametrosSeleccionados = this.state.parametrosSeleccionados.map( (parametros, index) => {
            if (index === indexJuegoSeleccionado) {
                return parametrosJuegoSeleccionado
            }
            return parametros
        })

        this.setState(
            { parametrosSeleccionados }, 
            () => this.setState({ plantillaId: this.getNombrePlantilla() }) 
        )
    }

    getNombrePlantilla = () => {
        const { juegos } = this.props.configIndice
        const { indexJuegoSeleccionado, parametrosSeleccionados } = this.state
        const parametrosJuegoSeleccionado = parametrosSeleccionados[indexJuegoSeleccionado]
        const nombre = juegos[indexJuegoSeleccionado].id + parametrosJuegoSeleccionado.reduce( (acc, opcionId) => acc + opcionId, "" )
        return nombre
    }

    getMinFC = () => {
        const { juegos } = this.props.configIndice
        const { indexJuegoSeleccionado, parametrosSeleccionados } = this.state
        const parametrosJuegoSeleccionado = parametrosSeleccionados[indexJuegoSeleccionado]

        let minFC = 1
        juegos[indexJuegoSeleccionado].parametros.forEach( (parametro, index) => {
            const { opciones } = parametro
            const opcionSeleccionada = opciones.find( opcion => opcion.id === parametrosJuegoSeleccionado[index] )
            minFC = minFC * Number(opcionSeleccionada.minFC)
        })

        return minFC
    }

    handleEntrada = (entrada) => {
        // window.console.log('pantalla-seleccionar-juego handleEntrada entrada', entrada)
    }

    handleContinuar = () => {
        const { configIndice, onContinuar } = this.props
        const { plantillaId, indexJuegoSeleccionado } = this.state
        const juegoSeleccionado = configIndice.juegos[indexJuegoSeleccionado]
        const minFC = this.getMinFC()
        onContinuar(plantillaId, juegoSeleccionado.zona, minFC)
    }

    handleTip = () => {
        this.props.onTip()
    }

    render () {
        const { configIndice, onAtras } = this.props 
        const { indexJuegoSeleccionado } = this.state

        return (
            <div className="fondoMenus">
                <div className={"indice indiceGenerador"}>
                    { configIndice.adornos && 
                        configIndice.adornos.map( 
                            num => <img 
                                alt="" 
                                key={`adorno-${num}`} 
                                className={`adorno${num}`} 
                                src={`css/imagenes/menus/adorno${num}.png`} 
                            /> 
                        )
                    }
                    <PantallaIndice.CabeceraIndice 
                        libroId={'GameGenerator'} 
                        configIndice={ configIndice } 
                        onEntrada={ this.handleEntrada } 
                        onAtras={ onAtras } 
                    >
                        <div className='paso1cabecera botonIndicador' />
                        <div className='paso2cabecera' onClick={ this.handleContinuar } />
                        <div className="botonIndicaciones" onClick={ this.handleTip }>{ configIndice.textoTips }</div>
                    </PantallaIndice.CabeceraIndice>
                    <ContenedorIndiceGameGenerator 
                        configIndice={ configIndice } 
                        indexJuego={ indexJuegoSeleccionado } 
                        parametrosSeleccionados={ this.state.parametrosSeleccionados }
                        onSeleccionarJuego={ this.handleSeleccionarJuego }
                        onSeleccionarParametro = { this.handleSeleccionarParametro }
                    />

                    {/* { juegos.map( (juego, index) => <Juego 
                        key={ "juego-" + juego.id } 
                        {...juego}
                        seleccionado={ index === indexJuegoSeleccionado } 
                        onSeleccionarJuego={ () => this.handleSeleccionarJuego(index) }
                        onSeleccionarParametro={ this.handleSeleccionarParametro }
                    /> )} */}
                    <BotoneraIndice 
                        libroId={'GameGenerator'} 
                        configIndice={ configIndice } 
                        onAtras={ onAtras }
                        onContinuar={ this.handleContinuar }
                         />
                    {/* <h2>Plantilla: { this.state.plantillaId }</h2> */}
                    {/* <h2>Zona: { juegoSeleccionado.zona }</h2> */}
                    {/* <h2>minFC: { this.getMinFC() }</h2> */}
                </div>
            </div>
        )
    }
}

export default PantallaSeleccionarJuego